export const english = {
  id: 'en',
  jezik: 'English',
  idJezik: 'En',
  krunice: [
    {
      value: 'gospa',
      label: 'The Holy Rosary',
      pozdrav: 'Hail Mary and Jesus!',
      vjera: 'Jesus, which may increase our faith.',
      ufanje: 'Jesus, which may increase our hope.',
      ljubav: 'Jesus, which may increase our love.',
    },
    {
      value: 'rita',
      label: 'St. Rita Rosary',
      pozdrav: 'Saint Rita, patron saint of impossible causes, pray for us.',
      vjera:
        'Jesus, who through the intercession of Saint Rita may our faith increase!',
      ufanje:
        'Jesus, through the intercession of Saint Rita may He strengthen our hope!',
      ljubav:
        'Jesus, who may through the intercession of Saint Rita perfect our love!',
      gospodinePohitPomognes: 'Lord, hasten to help me.',
      bozePriteciUpomoc: 'O God, come to my assistance.',
      otajstvo1:
        'Saint Rita, you now enjoy the greatest blessings in Heaven. You were a lover of suffering and endurance. For the sake of our Lord Jesus Christ, I beg you, help me also, so that through your intercession I may bear all my sufferings and trials with love for our Lord Jesus Christ.',
      otajstvo2:
        'Saint Rita, you followed the commandments of Jesus Christ and forgave the murderer, encouraging your sons to forgive as well. I ask you, most dear intercessor and helper, assist me too, so that I may forgive with all my heart and soul.',

      otajstvo3:
        'Saint Rita, you remained a widow and embraced the holy convent, where the sweet law of sanctification is lived. Help me, dear saint, so that each day I may grow more and more in spirit and live for the glory of Jesus.',

      otajstvo4:
        'Saint Rita, in your refuge you disciplined your body with chains, fasting, and suffering for the love of the Lord Jesus Christ. I beg you, help me also, so that I may do penance, restrain my passions, live and bear witness to the love of Jesus.',

      otajstvo5:
        'Saint Rita, that bloody thorn which pierced your forehead became for you a heavenly source that eased your pain and a reward for the patience you so often showed in the hardships of your life, especially in the hastiness and anger of your husband. Help me also, that I may have the necessary patience throughout my life.',
      opis: 'She received a wound on her forehead that reminded her of Jesus Crown of Thorns. Immediately after her death, the faithful began to venerate her as a saint. She is the patron saint of the helpless and of hopeless causes.',
    },
    {
      value: 'blazenogOca',
      label: 'Prayer of the Blessed Father',
      ref1: 'O Father, I place myself into your hands. Do with me whatever you will. Whatever you may do, I thank you.',
      ref2: 'I am ready for everything, I accept everything, provided that your will is done in me and in all your creatures.',
      ref3: 'I desire nothing else, Father. I entrust my soul to you; I give it to you with all the love I have, because I love you',
      ref4: 'and I feel the need to give myself to you, to surrender myself into your hands without reserve, without measure, with boundless trust, because you are my Father.',
    },
    {
      value: 'gertruda',
      label: 'St. Gertrude Rosary',
      pozdrav: 'Saint Gertrude, pray for us.',
      vjera: 'Jesus.',
      ufanje: 'Jesus.',
      ljubav: 'Jesus.',
      vjecniOce:
        'Eternal Father, I offer You the most precious Blood of Your divine Son Jesus Christ, together with all the Holy Masses celebrated today throughout the world, for the souls in purgatory, for sinners in the Church, for sinners in my home and in my family, and for all unborn children.',
      presvetoSrceIsusovo:
        'Most Sacred Heart of Jesus, open the hearts and minds of sinners to the truth and the light of God. Immaculate Heart of Mary, pray for the conversion of sinners and for the whole world.',
      opisObecanjaIsusa:
        'Jesus promised Saint Gertrude that every time this prayer is recited—even if it is prayed multiple times a day—He would free one thousand souls from purgatory. In this chaplet, the prayer is said fifty times. If this chaplet is prayed only once, Jesus will free 50,000 souls from purgatory.Saint Gertrude prayed much for the poor souls in purgatory. Through Masses, penance, and good works, she shortened the sufferings of many souls in purgatory and opened the gates of Heaven for them. When a priest would raise the Host during Holy Mass, she would pray: “Lord, Holy Father, I offer You the sacred Host for all those who are on earth, in purgatory, and in Heaven.” At that moment, she would see many souls being delivered from the torments of purgatory and passing into Heaven.',
    },
    {
      value: 'bozijeMilosrde',
      label: 'Chaplet of Divine Mercy',
      pozdrav: 'Jesus, I trust in You!',
      vjera: 'Jesus.',
      vjecniOce:
        'Eternal Father, I offer You the Body and Blood, Soul and Divinity of Your dearly beloved Son, our Lord Jesus Christ, in atonement for our sins and those of the whole world.',
      pregorkaMuka:
        'For the sake of His sorrowful Passion, have mercy on us and on the whole world.',
      krajKrunice:
        'Holy God, Holy Mighty One, Holy Immortal One, have mercy on us and on the whole world.',
      zakljucnaMolitvaKrvi:
        'O Blood and Water, which gushed forth from the Heart of Jesus as a fountain of mercy for us, I trust in You!',
      zakljucnaMolitvaMarijo: 'Mary, Mother of Mercy, pray for us!',
      zakljucnaMolitvaIsuse: 'Jesus, I trust in You!',
      zakljucnaMolitvaGospodine:
        'Have mercy on us and on the whole world, O Lord',
      opis: 'The Chaplet of Divine Mercy is a Catholic prayer and devotion centered on God’s mercy and compassion for all people. Its text originates from the spiritual experiences of Saint Faustina Kowalska, a Polish nun who lived in the 20th century.',
      zaziv: 'Invocations to Divine Mercy',
    },
    {
      value: 'osobnaPredanje',
      label: 'Personal Prayer of Surrender',
    },
    {
      value: 'pobjede',
      label: 'Rosary of Victory',
      vjera: 'Jesus.',
      vjecniOce:
        'Eternal Father, we offer You the Most Precious Blood of Jesus Christ in atonement for our sins, for the consolation of the souls in purgatory, and for the needs of the Holy Church.',
      pobjedniceZlihDuhova:
        'Blood of Christ, conqueror of evil spirits – save us!',
      jaganjcevaKrv:
        'But they overcame him by the Blood of the Lamb and by the word of their testimony.',
      hvaljen: 'Praised and glorified forever be Jesus,',
      otkupioKrvlju: 'Who redeemed us with His Blood!',
    },
    {
      value: 'andeoska',
      label: 'The Chaplet of Saint Michael',
      oceNas: 'Our Father',
      zdravoMarije: '3x Hail Marys',
      zaziv1Naslov: 'First Invocation',
      zaziv1:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of Seraphim, O Lord, make us worthy of the flame of burning love.',
      uCast1Kora: '(in honor of the first angelic choir)',
      zaziv2Naslov: 'Second Invocation',
      zaziv2:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of Cherubim, O Lord, grant us the grace to abandon the path of sin and to hasten along the path of Christian perfection.',
      uCast2Kora: '(in honor of the second angelic choir)',
      zaziv3Naslov: 'Third Invocation',
      zaziv3:
        'By the intercession of Saint Michael the Archangel and the holy choir of Thrones, O Lord, pour into our hearts the spirit of true and sincere humility.',
      uCast3Kora: '(in honor of the third angelic choir)',
      zaziv4Naslov: 'Fourth Invocation',
      zaziv4:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of Dominions, O Lord, grant us the grace to govern our senses and to correct our disordered passions.',
      uCast4Kora: '(in honor of the fourth angelic choir)',
      zaziv5Naslov: 'Fifth Invocation',
      zaziv5:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of Powers, O Lord, deign to protect our souls from the snares and temptations of the devil.',
      uCast5Kora: '(in honor of the fifth angelic choir)',
      zaziv6Naslov: 'Sixth Invocation',
      zaziv6:
        'By the intercession of Saint Michael the Archangel and the admirable choir of heavenly Virtues, O Lord, do not allow us to fall into temptation, but deliver us from evil.',
      uCast6Kora: '(in honor of the sixth angelic choir)',
      zaziv7Naslov: 'Seventh Invocation',
      zaziv7:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of Principalities, O Lord, fill our souls with the spirit of true and sincere obedience.',
      uCast7Kora: '(in honor of the seventh angelic choir)',
      zaziv8Naslov: 'Eighth Invocation',
      zaziv8:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of Archangels, O Lord, grant us the gift of perseverance in faith and good works, so that we may attain the glory of Heaven.',
      uCast8Kora: '(in honor of the eighth angelic choir)',
      zaziv9Naslov: 'Ninth Invocation',
      zaziv9:
        'By the intercession of Saint Michael the Archangel and the heavenly choir of all Angels, O Lord, we ask You to protect us during this present life and, afterward, to lead us into heavenly glory.',
      uCast9Kora: '(in honor of the ninth angelic choir)',
      uCast10Kora: 'in honor of Saint Michael',
      uCast11Kora: 'in honor of Saint Gabriel',
      uCast12Kora: 'in honor of Saint Raphael',
      uCast13Kora: 'in honor of our Guardian Angel',
      slavniKneze:
        'Glorious Prince, Saint Michael, commander of the heavenly host, guardian of souls, conqueror of rebellious spirits, our excellent leader, after Jesus Christ, deign to deliver us from every evil, we who turn to you with confidence, and grant that, under your protection, we may faithfully serve our God every day.',
      moliZaNas:
        'Pray for us, Saint Michael the Archangel, that we may be made worthy of the promises of Christ.',
      pomolimoSe:
        'Almighty and eternal God, who in Your wondrous goodness and mercy, for the salvation of mankind, chose the glorious Saint Michael as Prince of Your Church, we beseech You to grant us his gracious protection, so that we may be free from all our spiritual enemies. At the hour of our death, do not abandon us to the ancient enemy, but let Your Archangel Michael lead us into the presence of Your divine majesty.',
    },
  ],
  daniTjedan: [
    { value: 'pon', label: 'Mon' },
    { value: 'uto', label: 'Tue' },
    { value: 'sri', label: 'Wed' },
    { value: 'cet', label: 'Thu' },
    { value: 'pet', label: 'Fri' },
    { value: 'sub', label: 'Sat' },
    { value: 'ned', label: 'Sun' },
  ],
  otajstvoSvjetla: 'The Luminous Mysteries',
  otajstvoZalosno: 'The Sorrowful Mysteries',
  otajstvoSlavno: 'The Glorious Mysteries',
  otajstvoRadosna: 'The Joyful Mysteries',
  uImeOcaSina:
    'In the name of the Father and of the Son † and of the Holy Spirit.',
  oceNas: 'Our father',
  isuse: 'Jesus',
  oceNasText:
    ', who art in heaven, hallowed be thy name, thy kingdom come, thy will be done on earth as it is in heaven. Give us this day our daily bread and forgive us our trespasses as we forgive those who trespass against us, and lead us not into temptation but deliver us from evil.',
  amen: 'Amen.',
  slavaOcu:
    'Glory be to the Father, and to the Son, † and to the Holy Spirit. As it was in the beginning, is now, and ever shall be, world without end.',
  zdravoMarijaPocetak:
    'Hail, Mary, full of grace, the Lord is with thee: blessed art thou among women, and blessed is the fruit of thy womb,',
  zdravoMarijaKraj:
    'Holy Mary, Mother of God, pray for us sinners, now, and at the hour of our death.',
  oMojIsuse:
    'O my Jesus, forgive us our sins, save us from the fires of hell, lead all souls to heaven especially those who are in most need of Your mercy.',
  zdravoKraljice:
    'Hail, holy Queen, mother of mercy; hail, our life, our sweetness and our hope. To thee do we cry, poor banished children of Eve; to thee do we send up our sighs, mourning and weeping in this valley of tears. \n Turn then, most gracious advocate, thine eyes of mercy towards us; and after this our exile, show unto us the blessed fruit of thy womb, Jesus.  \n O clement, O loving, O sweet Virgin Mary.',
  apostolskoUvod:
    ', it is for Your love, for the conversion of sinners, and in reparation for the sins done against the Immaculate Heart of Mary.',
  apostolskoVjerovanje: "The Apostles' Creed",
  apostolskoVjerovanjeText:
    "I believe in God, the Father almighty, creator of heaven and earth. I believe in Jesus Christ, God's only Son, our Lord, who was conceived by the Holy Spirit, born of the virgin Mary, suffered under Pontius Pilate, was crucified, died and was buried; he descended to the dead. On the third day he rose again; he ascended into heaven, he is seated at the right hand of the Father, and he will come to judge the living and the dead. I believe in the Holy Spirit, the holy Christian Church, the communion of saints, the forgiveness of sins, the resurrection of the body, and the life everlasting.",
  naslov0: 'Holy Mary rosary †',
  naslov1: '1. bead',
  naslov2: '2. bead',
  naslov3: '3. bead',
  naslov4: '4. bead',
  naslov5: '5. bead',
  naslov6: 'The first mystery',
  naslov7: '1. bead',
  naslov8: '2. bead',
  naslov9: '3. bead',
  naslov10: '4. bead',
  naslov11: '5. bead',
  naslov12: '6. bead',
  naslov13: '7. bead',
  naslov14: '8. bead',
  naslov15: '9. bead',
  naslov16: '10. bead ',
  naslov17: 'The second mystery',
  naslov18: '1. bead',
  naslov19: '2. bead',
  naslov20: '3. bead',
  naslov21: '4. bead',
  naslov22: '5. bead',
  naslov23: '6. bead',
  naslov24: '7. bead',
  naslov25: '8. bead',
  naslov26: '9. bead',
  naslov27: '10. bead second decade',
  naslov28: 'The third mystery',
  naslov29: '1. bead',
  naslov30: '2. bead',
  naslov31: '3. bead',
  naslov32: '4. bead',
  naslov33: '5. bead',
  naslov34: '6. bead',
  naslov35: '7. bead',
  naslov36: '8. bead',
  naslov37: '9. bead',
  naslov38: '10. bead',
  naslov39: 'The Fourth Mystery',
  naslov40: '1. bead',
  naslov41: '2. bead',
  naslov42: '3. bead',
  naslov43: '4. bead',
  naslov44: '5. bead',
  naslov45: '6. bead',
  naslov46: '7. bead',
  naslov47: '8. bead',
  naslov48: '9. bead',
  naslov49: '10. bead',
  naslov50: 'The fifth mystery',
  naslov51: '1. bead',
  naslov52: '2. bead',
  naslov53: '3. bead',
  naslov54: '4. bead',
  naslov55: '5. bead',
  naslov56: '6. bead',
  naslov57: '7. bead',
  naslov58: '8. bead',
  naslov59: '9. bead',
  naslov60: '10. bead',
  naslov61: 'The end of the Rosary',
  prvaDeseticaRita:
    'Jesus, who through the intercession of Saint Rita may grant us patience in the difficult moments of life.',
  drugaDeseticaRita:
    'Jesus, who through the intercession of Saint Rita may give us the strength to forgive and love our enemies.',
  trecaDeseticaRita:
    'Jesus, who through the intercession of Saint Rita may grant us the necessary purity of soul and body.',
  cetvrtaDeseticaRita:
    'Jesus, who through the intercession of Saint Rita may deliver us from every evil of soul and body.',
  petaDeseticaRita:
    'Jesus, who through the intercession of Saint Rita may free us from all impatience and anger.',
  prvaDeseticaZalosna: 'Jesus, who was sweating blood for us!',
  prvaDeseticaSlavna: 'Jesus, who rose from the dead!',
  prvaDeseticaRadosna:
    'Jesus, whom you, the Virgin, by the Holy Spirit conceived!',
  prvaDeseticaSvjetla: 'Jesus, who was baptized on the Jordan River!',
  drugaDeseticaZalosna: 'Jesus ,which was whipped for us!',
  drugaDeseticaSlavna: 'Jesus, who ascended to heaven!',
  drugaDeseticaRadosna: 'Jesus, whom you, the Virgin, Elizabeth went to visit!',
  drugaDeseticaSvjetla:
    'Jesus, which was revealed to us at the wedding in Cana!',
  trecaDeseticaZalosna: 'Jesus, who for us was crowned with thorns!',
  trecaDeseticaSlavna: 'Jesus, who sent the Holy Spirit!',
  trecaDeseticaRadosna: 'Jesus, whom you, Virgin, gave birth to!',
  trecaDeseticaSvjetla:
    'Jesus, who proclaimed to us the Kingdom of God and called us to conversion!',
  cetvrtaDeseticaZalosna: 'Jesus, who carried for us a heavy cross!',
  cetvrtaDeseticaSlavna: 'Jesus, who took Thee, O Virgin, to heaven!',
  cetvrtaDeseticaRadosna: 'Jesus, whom you have shown, Virgin, in the temple!',
  cetvrtaDeseticaSvjetla:
    'Jesus, who was transformed on the mountain and revealed his glory to us!',
  petaDeseticaZalosna: 'Jesus, who was crucified for us!',
  petaDeseticaSlavna: 'Jesus, who crowned Thee Virgin, in heaven!',
  petaDeseticaRadosna: 'Jesus, whom you found, Virgin, in the temple!',
  petaDeseticaSvjetla:
    'Jesus, who was given to us in the mystery of the Eucharist!',
  krunicaKrozKorizma:
    '- during the Lenten season and the Paschal Triduum, the Sorrowful Mysteries (from Ash Wednesday until the Easter Vigil on Holy Saturday)',
  krunicaKrozBozic:
    '- during the Christmas season (from Christmas Eve until the Feast of the Baptism of the Lord), the Joyful Mysteries and the Mysteries of Light)',
  krunicaKrozUskrs:
    '- during the Easter season (from the Easter Vigil on Holy Saturday until the Solemnity of Pentecost), the Glorious Mysteries and the Mysteries of Light',
  litanijeBozanskogMilosrdja: [
    { tekst: 'Lord, have mercy.', odgovor: '' },
    { tekst: 'Christ, have mercy.', odgovor: '' },
    { tekst: 'Lord, have mercy.', odgovor: '' },
    { tekst: 'Christ, hear us.', odgovor: '' },
    { tekst: 'Christ, graciously hear us.', odgovor: '' },
    { tekst: 'God the Father of Heaven, have mercy on us.', odgovor: '' },
    {
      tekst: 'God the Son, Redeemer of the world, have mercy on us.',
      odgovor: '',
    },
    { tekst: 'God the Holy Spirit, have mercy on us.', odgovor: '' },
    { tekst: 'Holy Trinity, one God, have mercy on us.', odgovor: '' },
    {
      tekst: 'Divine Mercy, unfathomable mystery of the Most Holy Trinity,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, expression of His greatest power,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, revealed in the creation of the heavenly spirits,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, which called us forth from nothingness into existence,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, embracing the whole universe,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, granting us immortal life,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, shielding us from the punishments we have deserved,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, delivering us from the misery of sin,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, granting us justification through the Word made Flesh,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, pouring forth upon us from the wounds of Christ,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, flowing for us from the Most Sacred Heart of Jesus,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, giving us the Blessed Virgin as the Mother of Mercy,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, revealed in the founding of the Church embracing the whole world,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, revealed in the institution and administration of the Holy Sacraments,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, limitless in the Sacrament of Baptism and Penance,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'Divine Mercy, immeasurable in the Sacrament of the Eucharist and the Priesthood,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, calling us to the holy faith,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, in the conversion of sinners,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, sanctifying the righteous,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, perfecting the saints,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, source of relief for the sick and suffering,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, comfort and treasure of all the brokenhearted,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, hope of those in despair,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, accompanying all people always and everywhere,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, filling us with Your graces,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, peace of the dying,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, protecting us from the fires of hell,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, easing the sufferings of the souls in Purgatory,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, delight and boundless joy of all the saints,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, infinite in all the mysteries of faith,',
      odgovor: 'I trust in You!',
    },
    {
      tekst: 'Divine Mercy, inexhaustible source of miracles,',
      odgovor: 'I trust in You!',
    },
    {
      tekst:
        'The Lord is gracious and merciful, slow to anger and abounding in steadfast love.',
      odgovor: '',
    },
    {
      tekst: 'Therefore I will sing forever of the mercies of the Lord.',
      odgovor: '',
    },
    {
      title: 'Let us pray:',
      tekst:
        'O Eternal God, in whom mercy is endless and the treasury of compassion inexhaustible, look kindly upon us and increase Your mercy in us, so that in difficult moments we might not despair nor become discouraged, but with great confidence submit ourselves to Your holy will, which is Love and Mercy itself. Through our Lord Jesus Christ, King of Mercy, who with You and the Holy Spirit shows us mercy forever and ever. Amen.',
      odgovor: '',
    },
  ],
  molitvaPredanja: [
    { tekst: 'Lord Jesus Christ,', odgovor: '' },
    { tekst: 'I come before You just as I am.', odgovor: '' },
    { tekst: 'I am sorry for my sins.', odgovor: '' },
    { tekst: 'Please forgive me!', odgovor: '' },
    { tekst: 'In Your name, I forgive all those who', odgovor: '' },
    { tekst: 'have done something against me.', odgovor: '' },
    { tekst: 'I renounce Satan and all his evil powers.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Lord Jesus Christ,', odgovor: '' },
    { tekst: 'I completely surrender myself to You.', odgovor: '' },
    { tekst: 'I completely place myself into Your hands,', odgovor: '' },
    { tekst: 'into Your holy and merciful will.', odgovor: '' },
    { tekst: 'I surrender myself out of love and', odgovor: '' },
    {
      tekst:
        'in the love of the Holy Spirit – in the power of the Holy Spirit.',
      odgovor: '',
    },
    {
      tekst:
        'I surrender myself through the Immaculate Heart of the Virgin Mother Mary,',
      odgovor: '',
    },
    { tekst: 'through Her pure hands and', odgovor: '' },
    { tekst: 'through Her powerful and merciful intercession.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Merciful and compassionate God,', odgovor: '' },
    { tekst: 'I believe and trust in You.', odgovor: '' },
    { tekst: 'Now I invite You forever into my life,', odgovor: '' },
    { tekst: 'which You have given me as the greatest gift,', odgovor: '' },
    { tekst: 'so that I may serve You forever.', odgovor: '' },
    { tekst: 'Jesus, I accept You as my Lord,', odgovor: '' },
    { tekst: 'God and Savior.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Heal me and make me whole!', odgovor: '' },
    { tekst: 'Heal my body, spirit, and soul,', odgovor: '' },
    {
      tekst:
        'my mind and understanding, my psychological and physical illnesses.',
      odgovor: '',
    },
    { tekst: 'Jesus, heal my conscience,', odgovor: '' },
    { tekst: 'the wounds of my heart, my blood, and my nature.', odgovor: '' },
    { tekst: 'Jesus, I open my innermost being to You:', odgovor: '' },
    { tekst: 'enter into every wound within me!', odgovor: '' },
    { tekst: 'Touch me, Jesus,', odgovor: '' },
    { tekst: 'with Your holy right hand and', odgovor: '' },
    { tekst: 'with Your merciful love.', odgovor: '' },
    { tekst: 'Jesus, save me and', odgovor: '' },
    { tekst: 'heal me because I am Yours and', odgovor: '' },
    { tekst: 'I want to remain completely Yours.', odgovor: '' },
    { tekst: 'Jesus, enable me', odgovor: '' },
    { tekst: 'to know You and to serve You forever.', odgovor: '' },
    { tekst: 'Make me faithful in serving You alone.', odgovor: '' },
    {
      tekst: 'I offer myself to You and consecrate myself to You.',
      odgovor: '',
    },
    { tekst: 'Jesus, I ask for Your mercy:', odgovor: '' },
    { tekst: 'grant me spiritual sight and obedience.', odgovor: '' },
    { tekst: 'Transform and strengthen my body,', odgovor: '' },
    { tekst: 'my spirit, soul, and heart.', odgovor: '' },
    { tekst: 'Come, Lord Jesus, and', odgovor: '' },
    { tekst: 'protect me with Your Precious Blood', odgovor: '' },
    {
      tekst: 'and fill me with the fullness of the joy of the Holy Spirit.',
      odgovor: '',
    },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Lead me, Jesus,', odgovor: '' },
    { tekst: 'with Your strong hand in Your truth and', odgovor: '' },
    { tekst: 'on Your path.', odgovor: '' },
    { tekst: 'Jesus, never leave me', odgovor: '' },
    { tekst: 'without Your love and mercy.', odgovor: '' },
    { tekst: 'Jesus, You are my Savior and', odgovor: '' },
    { tekst: 'Redeemer, and therefore I surrender myself', odgovor: '' },
    { tekst: 'completely to Your merciful will and love.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Merciful Jesus, I trust in You.', odgovor: '' },
    { tekst: 'I offer and dedicate this prayer to You', odgovor: '' },
    {
      tekst: 'out of the love of my heart and in the power of the Holy Spirit.',
      odgovor: '',
    },
    { tekst: 'I give You my life forever', odgovor: '' },
    {
      tekst:
        '– on the altar of the Immaculate Heart of the Virgin Mother Mary,',
      odgovor: '',
    },
    { tekst: '– in the safe refuge of Her Immaculate Heart.', odgovor: '' },
    { tekst: 'Through the flame of Her maternal love,', odgovor: '' },
    { tekst: 'through Her immaculate hands,', odgovor: '' },
    { tekst: 'I place my surrender', odgovor: '' },
    { tekst: 'as a bouquet of flowers into Your Heart, Jesus.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'To Your merciful love,', odgovor: '' },
    { tekst: 'in honor of Your Divine Heart,', odgovor: '' },
    { tekst: 'for the praise and glory of the Holy Trinity,', odgovor: '' },
    {
      tekst: 'for the salvation of my soul in time and eternity,',
      odgovor: '',
    },
    {
      tekst: 'I surrender everything I have and everything I am.',
      odgovor: '',
    },
    { tekst: 'Amen.', odgovor: '' },
    { tekst: 'Alleluia, alleluia!', odgovor: '' },
  ],
  litanijeSvetogMihovila: [
    { tekst: 'Lord, have mercy!', odgovor: '' },
    { tekst: 'Christ, have mercy!', odgovor: '' },
    { tekst: 'Lord, have mercy!', odgovor: '' },
    { tekst: 'Christ, hear us!', odgovor: '' },
    { tekst: 'Christ, graciously hear us!', odgovor: '' },
    { tekst: 'God the Father of Heaven,', odgovor: 'have mercy on us!' },
    {
      tekst: 'God the Son, Redeemer of the world,',
      odgovor: 'have mercy on us!',
    },
    { tekst: 'God the Holy Spirit,', odgovor: 'have mercy on us!' },
    { tekst: 'Holy Trinity, one God,', odgovor: 'have mercy on us!' },
    { tekst: 'Holy Mary, Queen of Angels,', odgovor: 'pray for us!' },
    { tekst: 'Saint Michael the Archangel,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, Prince of the heavenly host,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, leader and comfort of Israel,',
      odgovor: 'pray for us!',
    },
    {
      tekst:
        'Saint Michael, entrusted with the mysteries of the Most Holy Trinity,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Saint Michael, guardian of Paradise,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, prince of the heavenly army,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, brightest star of the angelic choir,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, herald of divine justice,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, full of love for all mankind,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, most humble before God,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, most obedient to the divine commandments,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, invincible in the fight against heresy,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, victor in the battle against the powers of evil,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, conqueror of Lucifer and the rebellious angels,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, devoted to the Incarnate Word,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Saint Michael, light of the angels,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, sure guide in times of danger,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Saint Michael, spreader of glory,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, comforter of the discouraged,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Saint Michael, angel of peace,', odgovor: 'pray for us!' },
    { tekst: 'Saint Michael, in our illnesses,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, guide of those who wander,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, support of those who hope,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, guardian of the teachings of the Church,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, protector of the Catholic Church,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, generous dispenser of divine mercy,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Saint Michael, refuge of the poor,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, relief of the oppressed,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, light and hope of the dying,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, our strength in battle,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, our defender against all impurity,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, comforter of the souls in Purgatory,',
      odgovor: 'pray for us!',
    },
    {
      tekst: 'Saint Michael, honored by the Church and the angels,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Saint Michael, our advocate,', odgovor: 'pray for us!' },
    { tekst: 'Saint Michael, guardian of our souls,', odgovor: 'pray for us!' },
    { tekst: 'Saint Michael, guardian of virgins,', odgovor: 'pray for us!' },
    {
      tekst: 'Saint Michael, glory of all the saints,',
      odgovor: 'pray for us!',
    },
    { tekst: 'Holy angels and archangels,', odgovor: 'defend us!' },
    {
      tekst: 'Lamb of God, who takes away the sins of the world,',
      odgovor: 'spare us, O Lord!',
    },
    {
      tekst: 'Lamb of God, who takes away the sins of the world,',
      odgovor: 'graciously hear us, O Lord!',
    },
    {
      tekst: 'Lamb of God, who takes away the sins of the world,',
      odgovor: 'have mercy on us, O Lord!',
    },
    { tekst: 'Pray for us, Saint Michael the Archangel!', odgovor: '' },
    {
      tekst: 'That we may be made worthy of the promises of Christ.',
      odgovor: '',
    },
    { tekst: 'Let us pray:', odgovor: '' },
    {
      tekst:
        'Almighty and eternal God, who has given us Saint Michael the Archangel as our protector and defender, may our prayers preserve us from every evil and from the fires of hell. We ask this through Christ our Lord.',
      odgovor: 'Amen',
    },
  ],
};
